export const dataTop: any = [
  {
    title: '문학에 스며들기',
    member: '12명의 멤버',
    time: '30분 전 마지막 채팅',
    people: ['최은영', '황순원', '김소월'],
  },
  {
    title: '모두 모여 코딩방',
    member: '23명의 멤버',
    time: '2시간 전 마지막 채팅',
    people: ['민모리', '수방방', '김펄럭'],
  },
  {
    title: '한강 러닝 크루',
    member: '52명의 멤버',
    time: '방금 전 마지막 채팅',
    people: ['강점프', '오마일', '김러닝'],
  },
  {
    title: '애니 뭐볼까',
    member: '38명의 멤버',
    time: '5분 전 마지막 채팅',
    people: ['사토루', '탄지로', '나나미'],
  },
  {
    title: '철학을 해봐요',
    member: '13명의 멤버',
    time: '1시간 전 마지막 채팅',
    people: ['오니체', '나공자', '김테스'],
  },
  {
    title: '입시 미술 준비반',
    member: '30명의 멤버',
    time: '12분 전 마지막 채팅',
    people: ['황미술', '류석고', '유채색'],
  },
];

export const dataBottom: any = [
  {
    title: '넷플릭스 추천방',
    member: '105명의 멤버',
    time: '방금 전 마지막 채팅',
    people: ['기묘한', '종이의', '오징어'],
  },
  {
    title: '해외 유학 준비 모여!',
    member: '123명의 멤버',
    time: '방금 전 마지막 채팅',
    people: ['김팔락', '이팔락', '정펄럭'],
  },
  {
    title: '끝말잇기방',
    member: '99명의 멤버',
    time: '30분 전 마지막 채팅',
    people: ['장발산', '산기슭', '슭곰밤'],
  },
  {
    title: '오운완 인증',
    member: '87명의 멤버',
    time: '30분 전 마지막 채팅',
    people: ['김로니', '김콜먼', '황철순'],
  },
  {
    title: '밤샘 공부방',
    member: '39명의 멤버',
    time: '6시간 전 마지막 채팅',
    people: ['미통령', '김땡떙', '김터키'],
  },
  {
    title: '언어교환방',
    member: '15명의 멤버',
    time: '1시간 전 마지막 채팅',
    people: ['김영어', '최일어', '이중어'],
  },
];
